import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Text, Flex } from "@radix-ui/themes";

interface CompactRadioGroupProps {
  value: string;
  onChange: (value: string) => void;
  options: {
    label: string;
    value: string;
    description?: string;
  }[];
}

export function CompactRadioGroup({
  value,
  onChange,
  options,
}: CompactRadioGroupProps) {
  return (
    <RadioGroup
      value={value}
      onValueChange={onChange}
      style={{ display: "flex", flexDirection: "column", gap: "8px" }}
    >
      {options.map((option) => (
        <Flex key={option.value} align="start" gap="2">
          <RadioGroupItem
            value={option.value}
            id={option.value}
            style={{ marginTop: "4px" }}
          />
          <Flex direction="column" gap="1">
            <Text
              as="label"
              htmlFor={option.value}
              size="2"
              weight="medium"
              style={{ cursor: "pointer" }}
            >
              {option.label}
            </Text>
            {option.description && (
              <Text size="1" color="gray" style={{ cursor: "default" }}>
                {option.description}
              </Text>
            )}
          </Flex>
        </Flex>
      ))}
    </RadioGroup>
  );
}
